'use client';

import { ProfileListEditor } from './ProfileListEditor';
import { useProfileListEditorLabels } from './useProfileListEditorLabels';

export type BrandsServicesProductsEditorProps = {
  values: string[];
  isReadOnly: boolean;
  isSaving: boolean;
  onSave: (values: string[]) => Promise<boolean>;
};

export function BrandsServicesProductsEditor({
  values,
  isReadOnly,
  isSaving,
  onSave,
}: BrandsServicesProductsEditorProps) {
  const { title, tooltip, ...labels } = useProfileListEditorLabels(
    'brandsServicesProducts',
  );

  return (
    <ProfileListEditor
      title={title}
      tooltip={tooltip}
      values={values}
      isReadOnly={isReadOnly}
      isSaving={isSaving}
      onSave={onSave}
      labels={labels}
    />
  );
}
